import { SxProps, Theme } from '@mui/material';

export const forgotPasswordContainerSX: SxProps<Theme> = (theme) => ({
	p: '0',
	height: { md: '100%' },
	display: 'flex',
	borderRadius: '0',
	width: '100%',
	maxWidth: '1440px',
	[theme.breakpoints.down('md')]: {
		flexDirection: 'column',
	},
});

export const buttonSX: SxProps<Theme> = {
	p: 1,
};

export const formContainerSX: SxProps<Theme> = {
	maxWidth: 560,
	mx: 'auto',
	px: { xs: 2, md: 4 },
	py: 3,
};

export const espotContainerSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
};
